import type { ESPokemonSingleProduct } from "@ka-nabellinc/tcg-platform-es-schema";
import type { PokemonPack } from "@/types/pokemon/pack";
import { timestampToDate } from '@/utils/proto/timestamp'
import dayjs from 'dayjs'

export const getPokemonSingleProductInfoString = (
  data: ESPokemonSingleProduct
) => {
  let infoString = data.product_name;

  if (data.pm_card.pack.expansion_mark) {
    infoString += `[${data.pm_card.pack.expansion_mark}]`;
  }

  infoString += `[${data.pm_card.rarity.rarity_abbreviation}]`;

  return infoString;
};

/**
 * 収録ページ用に収録の一覧を並び替える関数
 * 下記優先順位で並び替える
 *
 * 1. シリーズの登録順の降順
 * 2. 収録発売日の降順
 * 3. 収録登録日の昇順
 *
 * Reference: https://www.notion.so/ka-nabell/S_-_01_PCG-1bbc52fc0b128114b0b5f2627c22adbb?source=copy_link#263c52fc0b128027aa7cf1093d0f98ef
 */
export const pokemonPackCompareFnForPackPage =
  (a: PokemonPack, b: PokemonPack) => {
    const winA = -1
    const winB = 1
    const draw = 0

    // 1. シリーズの登録順の降順
    const aSeriesCreatedAt = a.series?.createdAt
    const bSeriesCreatedAt = b.series?.createdAt
    if (!aSeriesCreatedAt) {
      return winB
    }
    if (!bSeriesCreatedAt) {
      return winA
    }
    const aSeriesCreatedAtDate = timestampToDate(aSeriesCreatedAt)
    const bSeriesCreatedAtDate = timestampToDate(bSeriesCreatedAt)
    if (aSeriesCreatedAtDate !== bSeriesCreatedAtDate) {
      return dayjs(bSeriesCreatedAtDate).toDate().getTime() - dayjs(aSeriesCreatedAtDate).toDate().getTime()
    }

    // 2. 収録発売日の降順
    const aPackReleasedAt = a.releasedAt
    const bPackReleasedAt = b.releasedAt
    if (!aPackReleasedAt) {
      return winB
    }
    if (!bPackReleasedAt) {
      return winA
    }
    const aPackReleasedAtDate = timestampToDate(aPackReleasedAt)
    const bPackReleasedAtDate = timestampToDate(bPackReleasedAt)
    if (aPackReleasedAtDate !== bPackReleasedAtDate) {

      return dayjs(bPackReleasedAtDate).toDate().getTime() - dayjs(aPackReleasedAtDate).toDate().getTime()
    }

    // 3. 収録登録日の昇順
    const aPackCreatedAt = a.createdAt
    const bPackCreatedAt = b.createdAt
    if (!aPackCreatedAt) {
      return winB
    }
    if (!bPackCreatedAt) {
      return winA
    }
    const aPackCreatedAtDate = timestampToDate(aPackCreatedAt)
    const bPackCreatedAtDate = timestampToDate(bPackCreatedAt)
    if (aPackCreatedAtDate !== bPackCreatedAtDate) {
      return dayjs(bPackCreatedAtDate).toDate().getTime() - dayjs(aPackCreatedAtDate).toDate().getTime()
    }

    return draw
  }